<template>
  <el-container>
    <el-main style="width: 70%">
      <div style="margin-bottom: 10px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
          <el-breadcrumb-item
            ><span class="item_font"
              >快捷回复公共库设置</span
            ></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="searchBox">
        <el-form label-width="0">
          <el-form-item label="" style="width: 30%">
            <el-input
              size="mini"
              v-model="input3"
              placeholder="输入内容搜索"
              suffix-icon="el-icon-search"
              @input="inputContent"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button
              type="primary"
              size="mini"
              @click="importAction"
              class="item_font"
              >导入</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="addFolder"
              class="item_font"
              >新建目录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div style="width: 100%" class="item_font">
        <el-table
          :data="showData"
          border
          highlight-current-row
          row-key="id"
          style="width: 100%"
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
          :indent="10"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          @row-click="thisRowClick"
          v-loading="loading"
          :max-height="maxHeight()"
        >
          <el-table-column width="100" property="index" label="序号">
          </el-table-column>
          <el-table-column property="title" label="标题"></el-table-column>
          <el-table-column property="content" label="内容"></el-table-column>
          <!-- <el-table-column property="sort" label="使用频率" sortable=""></el-table-column> -->
          <el-table-column property="operate" label="操作" width="220px">
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-around;
                "
              >
                <el-button
                  v-show="scope.row.dataType == 0"
                  type="text"
                  size="small"
                  @click="add(scope)"
                  class="item_font"
                  >添加</el-button
                >
                <div
                  v-show="scope.row.dataType == 1"
                  style="text-align: center"
                >
                  <span style="color: rgba(255, 255, 255, 0); user-select: none"
                    >添加</span
                  >
                </div>
                <el-button
                  type="text"
                  size="small"
                  @click="handleEdit(scope.$index, scope.row)"
                  class="item_font"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click.native.prevent="deleteRow(scope.row)"
                  class="item_font"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="up(scope.row)"
                  class="item_font"
                  >移动</el-button
                >
                <!-- <el-button type="text" size="small" @click="down(scope)">下移</el-button> -->
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column property="sortNum" label="排序序号" width="100px">
						<template slot-scope="scope">
							<div>
								<el-input v-model="scope.row.sortNum" onkeyup="value=value.replace(/[^\d]/g,'')" size="mini" @blur="changeSort(scope.row)"></el-input>
							</div>
						</template>
						
					</el-table-column> -->
        </el-table>
      </div>
      <div class="item_font" v-show="addFolders">
        <el-dialog
          :title="act"
          :visible.sync="addFolders"
          width="60%"
          center
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          "
        >
          <el-form
            :model="fileData"
            label-position="left"
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin-left: 30px;
              margin-right: 30px;
            "
          >
            <el-form-item label="目录标题:">
              <el-input v-model="fileData.title" style="width: 70%"></el-input>
            </el-form-item>
            <!-- <el-form-item label="排列序号:" >
							<el-input v-model="fileData.sortNum"  style="width: 70%;" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入数字0~9999"></el-input>
						</el-form-item> -->
            <el-form-item label="回复内容:" v-show="fileData.dataType === 1">
              <el-input
                v-model="fileData.content"
                type="textarea"
                style="width: 70%"
                :autosize="{ minRows: 5, maxRows: 10}"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-model="fileData.pId"
              v-show="fileData.dataType === 0"
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
              "
            >
              <el-checkbox
                label="放在当前选定的目录下"
                v-model="noRoot"
                @change="handleCheckNoRoot"
                :disabled="tableData.length == 0 || rowId == ''"
              ></el-checkbox>
              <el-checkbox
                label="放在根目录下"
                v-model="isRoot"
                @change="handleCheckIsRoot"
              ></el-checkbox>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              @click="
                addFolders = false;
                resetForm();
              "
              >取 消</el-button
            >
            <el-button type="primary" @click="condirmAddFolder"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </div>
      <div class="item_font" v-show="addReply">
        <el-dialog
          :title="act"
          :visible.sync="addReply"
          width="60%"
          center
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          "
        >
          <el-form
            :model="replyData"
            label-position="left"
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin-left: 30px;
              margin-right: 30px;
            "
          >
            <el-form-item label="回复标题:">
              <el-input v-model="replyData.title" style="width: 80%"></el-input>
            </el-form-item>
            <!-- <el-form-item label="排列序号:" >
							<el-input v-model="replyData.sortNum" style="width: 80%;" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入数字0~9999"></el-input>
						</el-form-item> -->
            <el-form-item
              label="回复内容:"
              v-show="dataType == 0 ? false : true"
            >
              <el-input
                v-model="replyData.content"
                type="textarea"
                style="width: 80%;"
                :autosize="{ minRows: 5, maxRows: 10}"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addReply = false">取 消</el-button>
            <el-button type="primary" @click="condirmAddReply">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div v-show="showImport" class="item_font">
        <el-dialog
          title="上传文件到服务器"
          :visible.sync="showImport"
          width="50%"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :on-success="uploadSuccess"
            :data="importType"
            :headers="myHeaders"
            ref="upload"
            :file-list="fileList"
            :before-upload="beforeUpload"
            accept=".xls,.xlsx"
            style="width: 60%; margin: 0 auto; margin-bottom: 3.125rem"
          >
            <el-button size="small" type="primary">点击上传文件</el-button>
            <div slot="tip" class="el-upload__tip">
              支持上传xls和xlsx格式的文件
            </div>
          </el-upload>
        </el-dialog>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          width: 60%;
          margin-left: 20%;
          margin-top: 3%;
          justify-content: space-around;
        "
      >
        <el-pagination
          background
          :pager-count="9"
          :page-size="10"
          layout="prev, pager, next, total"
          :total="total"
          @prev-click="pre"
          @next-click="next"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>

      <div class="item_font">
        <el-dialog
          title="移动位置"
          :visible.sync="sortNum"
          width="400px"
          center
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <div
            style="display: flex; width: 300px; margin-left: 50px"
            class="item_font"
          >
            <span style="line-height: 30px">移动到第</span>
            <el-input
              size="mini"
              v-model="sortNumValue"
              style="width: 120px; margin-left: 20px; margin-right: 20px"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              placeholder="输入数字"
            ></el-input>
            <span style="line-height: 30px">行</span>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="sortNum = false" size="mini" class="item_font"
              >取 消</el-button
            >
            <el-button
              type="primary"
              @click="condirmSortnum"
              size="mini"
              class="item_font"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { maxHeight } from "../../utils/tableHeight";
import { MessageBox } from "element-ui";
export default {
  data() {
    return {
      total: 0,
      page: 1,
      act: "",
      input3: "",
      showImport: false,
      addFolders: false,
      addReply: false,
      noRoot: false,
      isRoot: true,
      rowId: "",
      fileData: {
        pId: "0",
        title: "",
        content: "",
        attributionType: 0,
        dataType: 0,
      },
      tableData: [],
      replyData: {
        id: "",
        pId: 0,
        title: "",
        content: "",
        attributionType: 0,
        dataType: 1,
      },
      showData: [],
      // uploadUrl: 'http://192.168.0.182:8050/manager/QuickReplyQuery/excelImport',
      uploadUrl:
        JSON.parse(localStorage.getItem("siteObj")).webUrl +
        "/manager/QuickReplyQuery/excelImport",
      importType: {
        attributionType: 0,
        userId: this.util.getLocalAccount().id,
      },
      myHeaders: {
        Authorization: localStorage.getItem("token"),
      },
      fileList: [],
      dataType: 0,
      loading: true,
      sortNum: false,
      sortNumValue: "",
      quickCommonReplyISchange: false,
    };
  },
  mounted() {
    this.quickReplySel();
  },
  watch: {
    tableData: {
      handler(newVal, oldVal) {
        console.log("newVal, oldVal", newVal, oldVal);
        if (newVal) {
          this.quickCommonReplyISchange = !this.quickCommonReplyISchange;
          localStorage.setItem(
            "quickCommonReplyISchange",
            this.quickCommonReplyISchange
          );
          console.log("成功改变quickCommonReplyISchange值");
        }
      },
      deep: true,
    },
  },
  methods: {
    maxHeight,
    headerStyle({ rowIndex, columnIndex }) {
      if (rowIndex == 0 && columnIndex == 3) {
        return "text-align:center;color:#000000";
      } else {
        return "text-align:left;padding:15px;color:#000000";
      }
    },
    cellStyle({ columnIndex }) {
      if (columnIndex == 3) {
        return "text-align:center";
      } else {
        return "text-align:left;padding:15px;";
      }
    },
    // 导入快捷回复
    importAction() {
      this.showImport = true;
    },
    async handleChange(file, fileList) {
      console.log("quick handleChange file = ", file);
      console.log("quick handleChange fileList = ", fileList);
      // this.fileList = fileList.slice(-3)
      // console.log('quick handleChange file = ', file)
      // console.log('quick handleChange fileList = ', fileList)
      // let param = new FormData()
      // param.append('file', file)

      // const response = await this.util.uploadImageRequest({
      // 	method: "POST",
      // 	data: {
      // 		file: param,
      // 	},
      // });
      // console.log("quick handleChange response = ", response);
    },
    beforeUpload(file) {
      console.log("beforeUpload", file);
      const isJPG = file.type === "excel" || "xls" || "xlsx";
      const isLt10M = file.size < 1024 * 1024 * 10;
      if (!isJPG) {
        this.$message.error("只能上传xls格式文件!!");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("上传的文件大小不能超过 10MB!");
        return false;
      }
    },

    uploadSuccess(res, file) {
      console.log("quick uploadSuccess res = ", res);
      console.log("quick uploadSuccess file = ", file);
      if (res.resultCode === "10000") {
        const tipMsg = "导入文件成功!";
        this.$message.success(tipMsg);
        this.showImport = false;
        this.$refs.upload.clearFiles();
        this.quickReplySel();
      } else {
        const tipMsg = res.desc;
        this.$refs.upload.clearFiles();
        console.log("quick uploadSuccess file = ", file);
        this.$message.error(tipMsg);
      }

      // this.form.logoUrl = this.util.BASE_IMAGE_URL  + res.data.fileUrl
      // console.log("图片URL",this.form.logoUrl)
      // console.log("上传图片成功",res)
      // console.log(file)
    },

    // 获取快捷回复内容
    async quickReplySel() {
      console.log("Quick Reply Select", this.page);
      // console.log(this.noRoot)
      // console.log(this.isRoot)
      var api = "/manager/quickReply/select";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          attributionType: 0,
        },
      });
      for (var i = 0; i < response.data.length; i++) {
        this.getTree(i, response.data[i]);
      }
      // this.page=1
      this.tableData = response.data;
      this.total = this.tableData.length;
      this.showData = this.tableData.slice(
        (this.page - 1) * 10,
        this.page * 10
      );
      this.loading = false;
      console.log("展示数据", this.showData);
      console.log("公共库快捷回复数据", response.data);
    },
    getTree(index, data) {
      data.children = data.quickReplyVoList;
      data.label = data.title;
      if (data.children != null) {
        data.index = String(index + 1);
        for (var i = 0; i < data.children.length; i++) {
          this.getTree(i, data.children[i]);
        }
      } else {
        data.index = "\xa0\xa0\xa0\xa0\xa0\xa0" + String(index + 1);
      }
    },
    // 添加目录
    async addFolder() {
      if (this.currentType != 1) {
        this.fileData.dataType = 0;
        this.act = "新建目录";
        this.set();
      } else {
        let tipMsg = "不能在内容下创建目录，请重新选择";
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "error",
          showCancelButton: false,
        });
      }
    },
    handleCheckNoRoot() {
      if (this.noRoot) {
        this.fileData.pId = this.rowId;
        this.isRoot = false;
        this.noRoot = true;
      } else {
        this.noRoot = false;
        this.isRoot = true;
      }
      console.log("根目录", this.isRoot);
      console.log(this.noRoot);
    },
    handleCheckIsRoot() {
      if (this.isRoot) {
        this.isRoot = true;
        this.noRoot = false;
      } else {
        this.noRoot = true;
        this.isRoot = false;
      }
      console.log("根目录", this.isRoot);
      console.log(this.noRoot);
    },
    async condirmAddFolder() {
      console.log("condirmAddFolder", this.fileData);
      console.log("父目录", this.fileData.pId);
      if (this.fileData.pId != "") {
        if (this.fileData.title != "") {
          var api = "/manager/quickReply/add";
          const response = await this.util.postRequest({
            url: api,
            method: "POST",
            data: this.fileData,
          });
          if (response.resultCode === "10000") {
            if (this.fileData.dataType == "1") {
              this.$message.success("新增回复成功");
            } else {
              this.$message.success("创建目录成功");
            }

            this.addFolders = false;
            this.isRoot = true;
            this.noRoot = false;
            this.quickReplySel();
            this.fileData = {
              pId: "0",
              title: "",
              content: "",
              attributionType: 0,
              dataType: 0,
              sortNum: "",
            };
          } else {
            this.$message.error(response.desc);
          }
        } else {
          const tipMsg = " 目录标题不能为空！";
          MessageBox.alert(tipMsg, " 保存失败 ", {
            confirmButtonText: "确定",
            cancelButtonText: null,
            type: "warning",
            showCancelButton: false,
          });
        }
      } else {
        const tipMsg = "请选择正确的目录位置";
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "warning",
          showCancelButton: false,
        });
      }

      // console.log(this.isRoot)
    },

    // 添加回复
    async add(scope) {
      console.log("添加回复", scope);
      this.fileData.dataType = 1;
      this.fileData.pId = scope.row.id;
      this.act = "新增快捷回复标题";
      this.set();
    },

    // 编辑回复
    handleEdit(index, row) {
      console.log(index, row);
      this.addReply = true;
      this.replyData = {
        id: row.id,
        // pId:row.pId,
        title: row.title,
        content: row.content,
        // attributionType:0,
        // dataType:row.dataType,
        sortNum: Number(row.sortNum),
      };
      this.dataType = row.dataType;
      if (row.pId === "0") {
        this.act = "编辑快捷回复标题";
      } else {
        this.act = "编辑快捷回复内容";
      }
    },

    // 提交编辑、添加回复的内容
    async condirmAddReply() {
      this.replyData.sortNum = Number(this.replyData.sortNum);
      var api = "";
      var response = {};
      if (this.replyData.title != "") {
        if (this.act == "编辑快捷回复标题" || this.act == "编辑快捷回复内容") {
          api = "/manager/quickReply/edit";
          response = await this.util.postRequest({
            url: api,
            method: "POST",
            data: this.replyData,
          });
        } else {
          api = "/manager/quickReply/add";
          response = await this.util.postRequest({
            url: api,
            method: "POST",
            data: this.replyData,
          });
        }

        if (response.resultCode === "10000") {
          const tipMsg = this.act + "成功！";
          this.$message({
            message: tipMsg,
            type: "success",
          });
          this.act = "";
          this.addReply = false;
          this.quickReplySel();
          this.replyData = {
            id: "",
            pId: 0,
            title: "",
            content: "",
            attributionType: 0,
            dataType: 1,
          };
        } else {
          const tipMsg = response.desc;
          MessageBox.alert(tipMsg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: null,
            type: "warning",
            showCancelButton: false,
          });
        }
      } else {
        const tipMsg = "标题不能为空";
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "warning",
          showCancelButton: false,
        });
      }
    },

    // 删除回复
    deleteRow(scope) {
      const tipMsg = "是否确认删除";
      MessageBox.alert(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showCancelButton: true,
      }).then(() => {
        this.deleteReply(scope.id);
      });
    },

    async deleteReply(id) {
      console.log(111, id);
      var api = "/manager/quickReply/del";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: id,
        },
      });

      if (response.resultCode === "10000") {
        this.$message.success("删除成功");
        this.quickReplySel();
      } else {
        const tipMsg = response.desc;
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "warning",
          showCancelButton: false,
        });
      }
    },
    //编辑排序
    condirmSortnum() {
      this.replyData.sortNum = Number(this.sortNumValue);
      // console.log(1111111111,this.replyData)
      this.upAndDown();
      this.sortNum = false;
    },
    // async deleteClick(scope,index, rows) {
    // 	console.log('删除回复', scope);
    // 	this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
    // 		confirmButtonText: '确定',
    // 		cancelButtonText: '取消',
    // 		type: 'warning'
    // 	}).then(() => {
    // 		this.deleteRow(scope,index, rows)
    // 		// this.$message({
    // 		// 	type: 'success',
    // 		// 	message: '删除成功!'
    // 		// })
    // 	}).catch(() => {
    // 		this.$message({
    // 			type: 'info',
    // 			message: '已取消删除'
    // 		})
    // 	})

    // },

    set() {
      console.log(333333, this.fileData.dataType, this.fileData.pId);
      this.addFolders = true;
    },
    // 上移下移回复
    async up(row) {
      console.log("更改排列序号", row);
      // this.replyData.sortNum = row.sortNum
      // this.sortNumValue.value = this.replyData.sortNum
      this.act = "编辑快捷回复标题";
      this.replyData = {
        id: row.id,
        // pId: row.pId,
        title: row.title,
        content: row.content,
        // attributionType: 1,
        // dataType: row.dataType,
      };
      this.sortNum = true;
    },
    async upAndDown() {
      var api = "/manager/quickReply/upAndDown";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: this.replyData,
      });
      if (response.resultCode === "10000") {
        this.quickReplySel();
        const tipMsg = "移动成功！";
        this.$message({
          message: tipMsg,
          type: "success",
        });
      } else {
        const tipMsg = response.desc;
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "warning",
          showCancelButton: false,
        });
      }
    },
    // 搜索内容
    async inputContent(value) {
      console.log("当前输入内容", value);
      if (value != "") {
        var api = "/manager/QuickReplyQuery/selectByContent";
        const response = await this.util.postRequest({
          url: api,
          method: "POST",
          data: {
            attributionType: 0,
            content: value,
          },
        });
        if (response.resultCode === "10000") {
          this.tableData = [];
          // this.tableData.push(response.data.listVos)
          for (var i = 0; i < response.data.listVos.length; i++) {
            this.tableData.push(response.data.listVos[i]);
          }
          this.page = 1;
          this.total = this.tableData.length;
          this.showData = this.tableData.slice(
            (this.page - 1) * 10,
            this.page * 10 - 1
          );
        }
      } else {
        this.quickReplySel();
      }
    },
    // 点击表格的某一行
    thisRowClick(row) {
      console.log(row.id);
      this.rowId = row.id;
    },
    // 分页器相关方法
    pre(info) {
      console.log("pre：", info);
      this.page = info;
      this.showData = this.tableData.slice(
        (this.page - 1) * 10,
        this.page * 10
      );
    },
    next(info) {
      console.log("next：", info);
      this.page = info;
      this.showData = this.tableData.slice(
        (this.page - 1) * 10,
        this.page * 10
      );
    },
    handleCurrentChange(val) {
      this.start = 4 * (val - 1);
      this.page = val;
      this.showData = this.tableData.slice(
        (this.page - 1) * 10,
        this.page * 10
      );
      console.log("当前页码：", val, this.start);
    },
    getIndex($index) {
      return (this.page - 1) * 10 + $index + 1;
    },
    resetForm() {
      this.fileData = {
        id: "",
        pId: "0",
        title: "",
        content: "",
        attributionType: 0,
        dataType: 0,
        // sortNum:"",
      };
    },
  },
};
</script>

<style></style>
